import csv from 'csvtojson'

const fileUploadService = {
    uploadFileReader : async function(file) {
        return new Promise((resolve, reject) => {
          const fileReader = new FileReader()
          fileReader.onload = event => resolve(event.target.result)
          fileReader.onerror = error => reject(error)
          fileReader.readAsText(file)
        })
      },
      csvStringtoJson : async function(content) {
          return new Promise((resolve,reject)=> {
            csv({
                noheader:false,
                output: "json",
                quote: "/",
                flatKeys: false,
                downstreamFormat: true
            }).fromString(content)
            .then((csvRow)=>{ 
                resolve(csvRow);
            })
          });
        
      }
}

export default fileUploadService;


// WEBPACK FOOTER //
// ./src/api/fileUploadService.js